import { CssDevice } from '@gig/magic-common';
import { DEVICE_QUERY, DEVICE_QUERY_IS_DESKTOP, DEVICE_QUERY_IS_TABLET, DEVICE_QUERY_IS_PHONE, DEVICE_QUERY_IS_MOBILE, DEVICE_QUERY_IS_IOS, DEVICE_QUERY_IS_IPAD } from '@gig/magic-messages';
import { Device } from '@gig/magic-sdk/dist/methods/games';

var DeviceV2Service = /** @class */ (function () {
    function DeviceV2Service() {
        this.device = this.getDevice();
        this.registerDeviceQueries();
    }
    DeviceV2Service.prototype.registerDeviceQueries = function () {
        var _this = this;
        window.queryBus.subscribe(DEVICE_QUERY, function () {
            return _this.device;
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_DESKTOP, function () {
            return _this.isDesktop();
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_TABLET, function () {
            return _this.isTablet();
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_PHONE, function () {
            return _this.isPhone();
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_MOBILE, function () {
            return _this.isMobile();
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_IOS, function () {
            return _this.isIOS();
        });
        window.queryBus.subscribe(DEVICE_QUERY_IS_IPAD, function () {
            return _this.isIpad();
        });
    };
    DeviceV2Service.prototype.updateDevice = function (cssBreakpointsDevice) {
        this.cssBreakpointsDevice = cssBreakpointsDevice;
        this.device = this.getDevice();
    };
    DeviceV2Service.prototype.getUserAgent = function () {
        return (window && window.navigator.userAgent) || '';
    };
    DeviceV2Service.prototype.getMajorVersion = function (os, sp) {
        var userAgent = this.getUserAgent();
        var startString = userAgent.indexOf(os) + os.length;
        var endString = userAgent.indexOf(sp, startString);
        var version = userAgent.substring(startString, endString);
        return Number(version.trim().split('.')[0]) || null;
    };
    DeviceV2Service.prototype.isPhone = function () {
        return this.cssBreakpointsDevice === CssDevice.MOBILE;
    };
    DeviceV2Service.prototype.isTablet = function () {
        return (this.cssBreakpointsDevice === CssDevice.PHABLET ||
            this.cssBreakpointsDevice === CssDevice.TABLET);
    };
    DeviceV2Service.prototype.isMobile = function () {
        return this.isPhone() || this.isTablet();
    };
    DeviceV2Service.prototype.isDesktop = function () {
        return !this.isMobile();
    };
    DeviceV2Service.prototype.isAndroid = function () {
        return /Android/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isIOS = function () {
        return /iPhone|iPod|iPad/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isIphone = function () {
        return /iPhone/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isIpad = function () {
        return /iPad/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isIPod = function () {
        return /iPod/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isWM = function () {
        return /Windows Phone/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.isWM7 = function () {
        return (this.isWM() && this.getMajorVersion('Windows Phone OS', ';') === 7);
    };
    DeviceV2Service.prototype.isWM8Plus = function () {
        return this.isWM() && this.getMajorVersion('Windows Phone', ';') >= 8;
    };
    DeviceV2Service.prototype.isIosSafari = function () {
        return this.isIOS() && /Safari/i.test(this.getUserAgent());
    };
    DeviceV2Service.prototype.getDevice = function () {
        if (this.isDesktop()) {
            return Device.DESKTOP;
        }
        if (this.isIphone()) {
            return Device.IPHONE;
        }
        if (this.isAndroid()) {
            if (this.isTablet()) {
                return Device.ANDROID_TABLET;
            }
            return Device.ANDROID;
        }
        if (this.isIpad()) {
            return Device.IPAD;
        }
        if (this.isIPod()) {
            return Device.IPOD;
        }
        /**
        we need to pass a valid device param when fetchgames
        otherwise it will return the db games-array instead of the categories-array
        */
        if (this.isTablet() && !this.isIPod() && !this.isIpad()) {
            return Device.ANDROID_TABLET;
        }
        if (this.isWM8Plus()) {
            return Device.WM8;
        }
        if (this.isWM7()) {
            return Device.WM7;
        }
        return undefined;
    };
    return DeviceV2Service;
}());

export { DeviceV2Service };
